<script lang="ts">
  import { chat } from '../store';
  import Icon from './Icon.svelte';

  const capabilities = $derived($chat.capabilities);
</script>

<section class="empty">
  <div class="empty-art">
    <Icon name="users" size={42} />
  </div>
  <span class="empty-kicker">Private messaging hub</span>
  <h1>Chatsi</h1>
  <p>Telegram-style messaging across Telegram, Discord and peer-to-peer mesh, with LiveKit audio and video calls.</p>
  <div class="feature-chips">
    <span class={capabilities?.telegram.enabled ? 'chip ok' : 'chip'}>Telegram bots</span>
    <span class={capabilities?.discord.enabled ? 'chip ok' : 'chip'}>Discord bots</span>
    <span class={capabilities?.mesh.enabled ? 'chip ok' : 'chip'}>Pear mesh</span>
    <span class={capabilities?.livekit.enabled ? 'chip ok' : 'chip'}>LiveKit calls</span>
  </div>
  <button class="btn" onclick={() => chat.toggleSettings(true)}>Connect an account</button>
  <p class="empty-hint">Pick a chat on the left, create a mesh room, or connect a bot in Settings.</p>
</section>
